import React, { useEffect, useMemo } from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import './VouchersTranslate';
import paths from '../../_helpers/paths'
import Button from '../../_ui/Button/Button';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import { clearState, loadData, vouchersModule } from './VouchersDucks';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { vouchersColums } from './VouchersColums';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import ModalAdd from './Components/ModalAdd';

function VouchersPage() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const breadCrumbItems = useMemo(
    () => [
      {
        name: t('breadcrumbs_home'),
        href: paths.homePage
      },
      {
        name: t('vouchers_title'),
        href: paths.vouchersPage
      }
    ],
    [t]
  );
  const data = useSelector(state => state[vouchersModule].data);
  const loading = useSelector(state => state[vouchersModule].loading);
  const modalConfirmation = useSimpleModal();
  const { nextPage } = useTableFilter(filter => dispatch(loadData(filter)));

  useEffect(() => {
    return () => {
      dispatch(clearState())
    }
  }, [])


  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt3 px3">
        <div className="flex justify-between">
          <h3>{t('vouchers_title')}</h3>
          <Button
            icon={<AddIcon fontSize="small" className="mr1" />}
            size="small"
            text={t('groupsTablePage_add')}
            onClick={() => {
              modalConfirmation.open({})
            }}
          />
        </div>
        <div className="pt2">
          <StaticTablePagination
            columns={vouchersColums({ t, lang: i18n.language })}
            sortable={false}
            loading={loading}
            data={data}
            onClickLoadMore={() => nextPage()}
          />
        </div>
        {
          modalConfirmation.isOpen && <ModalAdd close={modalConfirmation.close}/>
        }
      </Paper>
    </>
  );
}

export default VouchersPage;
